import { $CurrentTraffic, $EnterTraffic } from '@lemon8/web-app-shared/atom';
import { defineProxyAtom } from '@lemon8/web-app-shared/util';
import { ExtractAtomValue } from 'jotai';

export interface ILegalEnterTraffic extends ExtractAtomValue<typeof $EnterTraffic> {
  serverTimeStamp: number;
  shouldReplaceTosLink: boolean;
}

export const $LegalEnterTraffic = defineProxyAtom<ILegalEnterTraffic, ExtractAtomValue<typeof $EnterTraffic>>(
  $EnterTraffic,
);
$LegalEnterTraffic.debugLabel = '$LegalEnterTraffic';

type TLegalCurrentTraffic = ExtractAtomValue<typeof $CurrentTraffic>;

export const $LegalCurrentTraffic = defineProxyAtom<TLegalCurrentTraffic, TLegalCurrentTraffic>($CurrentTraffic);
$LegalCurrentTraffic.debugLabel = '$LegalCurrentTraffic';
